import React from 'react'


interface Props {
  className?: string
}


const SearchSvg: React.FC<Props> = (props) => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={props.className}><path d="M9.714 15.429a5.714 5.714 0 100-11.43 5.714 5.714 0 000 11.43zM20.081 20l-6.367-6.286" strokeLinecap="round" strokeLinejoin="round" /></svg>
  )
}


SearchSvg.defaultProps = {
  className: 'w-8 h-8 stroke-current text-black'
}


export default SearchSvg;